import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "stepper" }
const _hoisted_2 = {
  key: 0,
  class: "stepper__section-name"
}

import { computed } from 'vue'
import type { QuestionnaireView } from '@/models/onboarding'

import Logo from '@/components/ui/Logo.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    view: {},
    hideSectionName: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

// Sections flagged `excludeFromStepper` (e.g., the intro) never get a segment,
// regardless of their array position, this doesn't assume the excluded
// section is always index 0.
const visibleSections = computed(() =>
  props.view.sections.filter((section) => !section.excludeFromStepper),
)

const currentVisibleIndex = computed(() =>
  visibleSections.value.findIndex(
    (section) => section.id === props.view.currentSection.id,
  ),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Logo, {
      class: "stepper__logo",
      withText: true
    }),
    (!__props.hideSectionName)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createTextVNode(" Step " + _toDisplayString(currentVisibleIndex.value + 1) + " ", 1),
          _cache[0] || (_cache[0] = _createElementVNode("strong", null, "•", -1)),
          _createTextVNode(" " + _toDisplayString(__props.view.currentSection.title), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      name: "slide",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          key: __props.view.currentSectionIndex,
          class: "stepper__steps"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleSections.value, (section, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: section.id,
              class: _normalizeClass(["stepper__step", {
            'stepper__step--prev': index < currentVisibleIndex.value,
            'stepper__step--current': index === currentVisibleIndex.value,
            'stepper__step--next': index > currentVisibleIndex.value,
          }]),
              style: _normalizeStyle({
            '--section-progress': __props.view.currentSectionProgress,
          })
            }, null, 6))
          }), 128))
        ]))
      ]),
      _: 1
    })
  ]))
}
}

})